import React, { useState, useEffect } from "react";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import ConstantInput from "components/sales/Input/constantInput/constantInput";

const ValetSupportFilterForm = ({ applyFilter }) => {
  const filterInputs = {
    status: "",
    role_id:"",
    phone_number:""
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);
  const [listStatus, setListStatus] = useState("");

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(
        localStorage.getItem("applyFilter") &&
          localStorage.getItem("applyFilter")
      );
      const status = await JSON.parse(
        localStorage.getItem("statusFilter") &&
          localStorage.getItem("statusFilter")
      );
      if (roles && status) {
        setFilterFieldsData(roles);
        setListStatus(status);
      }
    })();
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
        filterFieldsData &&
          localStorage.setItem("applyFilter", JSON.stringify(filterFieldsData));
        listStatus &&
          localStorage.setItem("statusFilter", JSON.stringify(listStatus));
      }}
    >
      <DropDownInput
        data={[
          { id: "OPEN", name: "OPEN" },
          { id: "CLOSED", name: "CLOSED" },
          { id: "RESPONDED", name: "RESPONDED" },
          { id: "REOPENED", name: "REOPENED" },
        ]}
        label={localization.status}
        value={
          filterFieldsData?.status !== null ? filterFieldsData?.status : ""
        }
        getIdValue={(val) => {
          setFilterFieldsData({
            ...filterFieldsData,
            status: val.id,
          });
        }}
      />

      <ConstantInput
          label={"User ID"}
          value={filterFieldsData && filterFieldsData.role_id}
          type="number"
          handleChange={(val) => {
              setFilterFieldsData({ ...filterFieldsData, role_id: val });
          }}
      />

      <ConstantInput
          label={"Phone Number"}
          value={filterFieldsData && filterFieldsData.phone_number}
          type="number"
          checkDigits={true}
          handleChange={(val) => {
              setFilterFieldsData({ ...filterFieldsData, phone_number: val });
          }}
      />

      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src={Images?.ArrowRight} alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            localStorage.setItem("applyFilter", JSON.stringify(filterInputs));
            applyFilter(filterInputs);
            localStorage.setItem("statusFilter", JSON.stringify({}));
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default ValetSupportFilterForm;
